<!--
 * @Author: liushuang
 * @Date: 2023-03-08 10:53:54
 * @LastEditors: liushuang
 * @Description: 
 * @FilePath: \Ats-web\src\components\upload\appendix.vue
-->
<template>
  <div class="upload-file-wrap">
    <a-upload 
      v-model:file-list="fileList"
      :showUploadList="false"
      :before-upload="beforeUploadM"
      :customRequest="uploadFileM"
      :on-remove="handleRemove"
      ref="upload"
      name="file"
      :progress="progress"
      :maxCount='uploadMaxNum'
    >
      <a-button class="uploadBtn upload-btn-box">
        <upload-outlined></upload-outlined>
        上传文件
      </a-button>
      <span class="upload-tip">仅能上传{{ fileTips }}文件，且不超过{{ fileSize }}M</span>
    </a-upload>
    <!-- 文件展示-->
    <div>
      <div
        class="old-file-wrap ml-file-wrap"
        v-for="(item, index) in oldFileList"
        :key="index"
        v-show="oldFileList.length"
      >
        <p class="listCss ats-grid-flex flex-align">
          <span class="img_name ats-grid-flex flex-align" @click="handlePreview">
            <svg v-if="icon=='only'" width="15px" height="14px" viewBox="0 0 15 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>paperclip</title>
                <g id="控件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Upload/_Resources/Progress+uploading" transform="translate(0.000000, -5.000000)" fill="#4F5B6E" fill-rule="nonzero">
                        <g id="paperclip" transform="translate(0.015611, 5.000000)">
                            <path d="M12.8495353,3.17353504 C12.1102994,2.44371615 11.1277905,2.03878438 10.0793625,2.03721488 L10.068376,2.03721488 C9.56456557,2.03721488 9.07331113,2.13138506 8.60559924,2.31658641 C8.12062282,2.50963528 7.68430099,2.79371532 7.31075928,3.16254852 L3.65538682,6.7755444 C3.23319051,7.1930322 3.00247357,7.75020576 3.00404308,8.34504739 C3.00561258,8.93831952 3.23946852,9.49549308 3.66323433,9.91455038 C4.08700014,10.3336077 4.64888221,10.5643246 5.24843235,10.5658941 L5.25314086,10.5658941 C5.8511215,10.5658941 6.41143406,10.3367467 6.83206086,9.92239789 L10.040125,6.75200186 C10.1468512,6.64684516 10.2049228,6.50715939 10.2049228,6.35962611 C10.2049228,6.21052332 10.1468512,6.07083756 10.040125,5.96725036 C9.93496827,5.86209366 9.793713,5.80559155 9.64461022,5.80559155 C9.49550744,5.80559155 9.35425217,5.86366316 9.24909547,5.96725036 L6.04103136,9.1376464 C5.83228746,9.34482079 5.55134643,9.45782501 5.25157135,9.45782501 L5.25000185,9.45782501 C4.94708778,9.4562555 4.66300773,9.34011228 4.45269433,9.13136839 C4.24081143,8.92105499 4.12309871,8.64168345 4.12309871,8.34347789 C4.1215292,8.04684182 4.23610292,7.76903979 4.44641632,7.5618654 L8.10178878,3.94730002 C8.62286377,3.43093353 9.32286211,3.14685349 10.0699455,3.14685349 L10.077793,3.14685349 C10.8280155,3.14842299 11.5327223,3.43721154 12.0616448,3.95828654 C12.5889978,4.48093103 12.8809254,5.17622086 12.8824949,5.91702627 C12.8840644,6.65783168 12.5968453,7.351552 12.0742008,7.86791848 L8.19595896,11.7053533 C7.42062448,12.4681317 6.38475251,12.8887585 5.27982241,12.8887585 L5.26883589,12.8887585 C4.15919727,12.8856195 3.11704729,12.4587147 2.3354348,11.6865193 C1.55382231,10.9143238 1.12220899,9.88472982 1.12063949,8.78764723 C1.11750048,7.69056464 1.5444053,6.66410969 2.31973977,5.89819223 L7.32645431,0.947979805 C7.43318051,0.842823105 7.49125212,0.703137339 7.49125212,0.555604058 C7.49125212,0.406501274 7.43318051,0.266815508 7.32645431,0.163228311 C7.2197281,0.0580716106 7.07847283,0 6.92937005,0 C6.78026727,0 6.639012,0.0580716106 6.5338553,0.161658808 L1.52714076,5.11344074 C1.02803881,5.60626467 0.641941078,6.18541128 0.378264576,6.83204651 C0.125574595,7.4567087 -0.00155514707,8.11589995 0,8.79078624 C0.00158385891,9.46724203 0.131852607,10.1264333 0.389251097,10.749526 C0.654497102,11.3961612 1.04216434,11.9753078 1.5444053,12.4712707 C2.04350725,12.9656642 2.63050136,13.3501924 3.28498411,13.6138689 C3.91278531,13.8665589 4.57982408,13.9952581 5.26569688,13.9983972 L5.27982241,13.9983972 C5.96098671,13.9983972 6.62174746,13.8728369 7.24640965,13.6232859 C7.8993229,13.3643179 8.48474751,12.9829287 8.98384946,12.4885353 L12.8620913,8.65266997 C13.2340636,8.28383677 13.5228521,7.85379295 13.7174705,7.37195554 C13.9058108,6.90581315 14.0015505,6.41612822 14,5.91231776 C13.9952725,4.87644578 13.5872017,3.90335393 12.8495353,3.17353504 Z" id="Shape"></path>
                        </g>
                    </g>
                </g>
            </svg>
            <img v-else class="file-type-icon" :src="setFileType(item.attachmentName)" alt="类型图标">
            <span class="file-name">{{ item.attachmentName ? item.attachmentName : item.fileName }}</span>
          </span>  
          <DeleteOutlined class="del-file"  @click="rightChaClick(index)"/>        
        </p>
        <a-progress v-if="!item.attachmentUrl && progress != 100" type="line" :percent="progress" status="active" />
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, ref, getCurrentInstance, computed,watch } from 'vue';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import { message, Upload } from 'ant-design-vue';
import axios from "axios";
import {
  getOssPolicy
} from '@/api/comm'

export default defineComponent({
  components: {
    UploadOutlined,
    // PaperClipOutlined,
    DeleteOutlined
  },
  props: {
    oldFileList: Array, //后台传输数据
    uploadMaxNum: Number, //上传个数
    fileTips: String, //上传格式
    fileSize: Number, //文件大小
    icon:String,//图片前缀图标
  },
  emits: ['fileUploadM', 'rightChaClick','handlePreview'],
  setup(props, {emit}) {
  // setup(props) {
    const data = reactive({
      uploadFlie: [],
      defaultFileList: [],
      uploadType: 'appendix_upload',
      item: {},
      progress: 0,
      ossItem: {//签名
        accessId: "",
        policy: "",
        signature: "",
        dir: "",
        host: "", //oss服务器上传地址
        expire: "",
        callback: "",
        fileName: "", //文件名
      },
      oldFileList:props.oldFileList,
    })
    const fileList = ref([]);
    const currentInstance = getCurrentInstance()
    //上传图片前类型判断
    const beforeUploadM = async(file) => {
      if((data.oldFileList.length + data.uploadFlie.length >= props.uploadMaxNum) && props.uploadMaxNum !=1){
        message.warning('您最多上传' + props.uploadMaxNum +"个文件")
        return false || Upload.LIST_IGNORE;
      }
      let fileType = props.fileTips.split('/');
      let fileName = file.name.split('.')
      if(!fileType.includes(fileName[fileName.length-1])){
        message.warning("您只能上传" + props.fileTips + "格式的文件");
        return false || Upload.LIST_IGNORE;
      }
      const sizeValue = props.fileSize; //文件大小
      const isUpSize = file.size < sizeValue * 1024 * 1024
      if (!isUpSize) {
        message.warning('文件大小' + '不能超过' + sizeValue + 'M')
        return false || Upload.LIST_IGNORE;
      }
      if(props.uploadMaxNum == 1){
        data.oldFileList = []
        data.uploadFlie = []
      }
    }
    //附件的icon设置
    const setFileType = computed(() => (name) => { //判断文件类型
      let type = ''
      if (name) {
        let arr = name.split('.');
        type = arr[arr.length - 1];
      }
      if (type == "pdf") {
        type = require(`../../assets/img/icon/pdf.png`);
      } else if (type == "jpg" || type == "jpeg") {
        type = require(`../../assets/img/icon/jpg.png`);
      } else if (type == "png") {
        type = require(`../../assets/img/icon/png.png`);
      } else if (type == "doc" || type == "docx") {
        type = require(`../../assets/img/icon/word.png`);
      }
      return type;
    })
    //开始上传-获取签名
    const uploadFileM = async(options) => {
      let file = options.file;
      data.item = { //添加进度条
        attachmentUrl: '',
        attachmentName: file.name,
        uid: file.uid
      };
      emit("fileUploadM", data.item, 1);
      let param1 = {
        fileName: file.name
      }
      getOssPolicy(data.uploadType, param1).then((res) => {
        if (res.success) {
          data.ossItem = res.data;

          const formData = new FormData();
          formData.append("OSSAccessKeyId", data.ossItem.accessId);
          formData.append("success_action_status", '200');
          formData.append("policy", data.ossItem.policy);
          formData.append("signature", data.ossItem.signature);
          formData.append("key", data.ossItem.dir + "/" + data.ossItem.fileName);
          formData.append("callback", data.ossItem.callback);
          formData.append("file", file);
          axios({
            method: "post",
            url: data.ossItem.host,
            data: formData,
            onUploadProgress: (progressEvent) => {
              data.progress = parseInt(
                ((progressEvent.loaded / progressEvent.total) * 100) | 0,
                10
              );
            },
          })
          .then((res) => {
            options.onSuccess(); //显示完成按钮小图标
            data.item = {
              attachmentUrl: res.data.url,
              attachmentName: file.name,
              uid: file.uid
            };
            // data.uploadFlie.push(data.item);
            // emit("fileUploadM", data.uploadFlie);
            emit("fileUploadM", data.item, 2);
          })
          .catch((err) => {
            options.onError(err)
            let uid = file.uid;
            let idx = currentInstance.value.ctx.$refs.upload.uploadFiles.findIndex(//关键作用代码，去除文件列表失败文件（uploadFiles为el-upload中的ref值）
              (item) => item.uid === uid
            );
            currentInstance.value.ctx.$refs.upload.uploadFiles.splice(idx, 1); // 关键作用代码，去除文件列表失败文件
          });
        }else{
          message.warning(res.message)
        }
      });
    }
    //删除上传的文件
    const handleRemove = (file) => {
      let uid = file.uid;
      let index = data.uploadFlie.findIndex((item) => item.uid === uid); // 关键作用代码，去除文件列表失败文件（uploadFiles为el-upload中的ref值）
      if (index != -1) {
        data.uploadFlie.splice(index, 1);
        emit("fileUploadM", data.uploadFlie);
      }
    }
    //删除后台文件
    const rightChaClick = (index) => {
      emit("rightChaClick", index);
    }

    //预览
    const handlePreview=()=>{
      emit('handlePreview')
    }

    watch(()=> props.oldFileList, (newVal)=> {
      data.oldFileList = newVal
    })
    return {
      ...toRefs(data),
      beforeUploadM,
      setFileType,
      uploadFileM,
      handleRemove,
      rightChaClick,
      currentInstance,
      fileList,
      handlePreview,
    }
  },
})
</script>
<style scoped>
.upload-btn-box {
  margin-right: 16px;
}
.upload-tip {
  height: 18px;
  font-size: 14px;
  font-weight: 400;
  color: #4F5B6E;
  line-height: 14px;
  /* margin-left: 16px; */
}
::v-deep .ant-progress-status-success .ant-progress-bg {
  background-color: #507AFD;
}
.listCss {
  width: 100%;
  height: 100%;
  padding: 0 4px 0 0;
  transition: background-color 0.3s;
  justify-content: space-between;
  margin-top: 12px;
}
.old-file-wrap:first-child .listCss {
  margin-top: 14px;
}
.img_name,
.del-file {
  color: rgba(0, 0, 0, 0.45);
}
.file-name {
  flex: 1;
  margin: 0;
  padding: 0 8px;
  display: inline-block;
  width: 100%;
  max-width: 380px;
  overflow: hidden;
  line-height: 1.5715;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.file-name,
.ant-upload-list {
  color: #333333;
}
/* .file-name:hover {
  color: #507AFD;
} */
.del-file {
  padding: 0 5px;
  /* display: none; */
}
.old-file-wrap:hover .listCss {
  background: #f5f5f5;
}
/* .old-file-wrap:hover .del-file {
  display: block;
} */
.file-type-icon {
  width: 30px;
  height: 30px;
}
.del-file{
  color: #507AFD!important;
}
.del-file:hover {
  color: #476DE3!important;
}
</style>
<style>
/* .old-file-wrap .ant-upload-list-item-name:hover {
  color: #507AFD;
} */
.ml-file-wrap .ant-progress-outer {
  padding-left: 42px;
}
.ant-progress-bg {
  height: 2px!important;
}
.ant-progress-success-bg, 
.ant-progress-bg {
  background-color: #507AFD;
}
.ant-progress-inner {
  background-color: rgba(0,0,0,0.04);
}
</style>